// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "8c392a208e9dab55","82": "f99eb624df423f48",}[chunkId] + ".js"
}